import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Tooltip } from "@material-ui/core";
import type { KeyboardEventHandler } from "react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiFormLabel-root": {
			transform: "translate(14px, -6px) scale(0.75) ",
			backgroundColor: "#FFFF",
			transition: "none !important",
			left: -3.5,
			padding: "0 5px",
		},
		"& .MuiInputBase-input": {
			backgroundColor: "#FFFF",
			color: "black",
			paddingRight: 45,
		},
	},
}));

type Props = {
	onKeyDown: KeyboardEventHandler<HTMLDivElement> | undefined;
};

export const SearchFilter = ({ onKeyDown }: Props) => {
	const classes = useStyles();
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get("search") ?? "";
	const [localValue, setLocalValue] = useState(search);

	// Debounce the search parameter update
	useEffect(() => {
		const timeoutId = setTimeout(() => {
			if (localValue !== search) {
				if (localValue === "") {
					searchParams.delete("search");
				} else {
					searchParams.set("search", localValue);
				}
				setSearchParams(searchParams, { replace: true });
			}
		}, 500);

		return () => clearTimeout(timeoutId);
	}, [localValue, search, searchParams, setSearchParams]);

	// Update local value when search params change externally
	useEffect(() => {
		setLocalValue(search);
	}, [search]);

	const handleFilter = (e: any) => {
		setLocalValue(e.target.value);
	};

	return (
		<div
			style={{
				position: "relative",
				display: "flex",
				alignItems: "center",
				height: "45px",
			}}
		>
			<Tooltip
				title="Search within the last 20 work orders for this asset"
				placement="top"
			>
				<TextField
					className={classes.root}
					style={{ borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
					label="Search"
					placeholder="Search last 20 orders..."
					variant="outlined"
					margin="dense"
					onKeyDown={onKeyDown}
					value={localValue}
					onChange={handleFilter}
					fullWidth
					autoComplete="off"
				/>
			</Tooltip>
			<>
				<Tooltip
					title="Search within the last 20 work orders for this asset"
					placement="top"
				>
					<i
						className="fa fa-search"
						style={{
							position: "absolute",
							right: 17,
							top: 17,
							cursor: "pointer",
						}}
					></i>
				</Tooltip>
			</>
		</div>
	);
};
